import template from './datepicker.html';
import controller from './datepicker.controller';

let datePickerComponent = {
  require: {
    ngModel: '^ngModel'
  },
  bindings: {
    autoclose: '<',
    todayHighlight: '<',
    dateFormat: '<'
  },
  template,
  controller
};

export default datePickerComponent;



// WEBPACK FOOTER //
// ./client/app/shared/ui/datepicker/datepicker.component.js